import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import type { Role } from '@/types';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Si présent, restreint l'accès à ces rôles uniquement */
  roles?:  Role[];
}

export const ProtectedRoute = ({ children, roles }: ProtectedRouteProps) => {
  const { accessToken, user } = useAuthStore();
  const location = useLocation();

  if (!accessToken || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
